<template>
  <v-responsive max-width="1080" class="mx-auto">
    <v-card tag="section" class="mb-md-10 container" flat>
      <v-card-title class="pl-0 text-subtitle-1">メール配信設定</v-card-title>
      <v-card-subtitle class="pl-0">配信停止するメールアドレスを入力してください</v-card-subtitle>
      <validation-observer ref="observer" v-slot="{ invalid }">
        <v-card-text class="pa-0">
          <vb-form-row item-name="メールアドレス" :required="true">
            <template #input>
              <v-sheet class="col-12 pa-0" :max-width="$vuetify.breakpoint.mdAndUp? 400: null">
                <validation-provider v-slot="{ errors }" name="メールアドレス" :rules="`required|email_character|max:${emailAddressMaxLength}`"
                                     mode="passive" ref="email">
                  <v-text-field
                    type="email"
                    v-model="unsubscribeEmailAddress"
                    @blur="$refs.email.validate(); blurBgColorChange($event, errors[0]);"
                    @focus="focusBgColorChange($event, errors[0]); message = null;"
                    :error-messages="errors"
                    outlined
                    required
                    dense
                    height="44px"
                    :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
                    autocomplete="new-password"
                    name="email"
                    hide-details="auto"
                    solo
                    flat
                    :maxlength="emailAddressMaxLength"
                  >
                    <template #label><span class="text-body-2">example@vaboo.jp</span></template>
                  </v-text-field>
                </validation-provider>
                <v-alert
                  v-if="message"
                  :icon="false"
                  colored-border
                  class="pl-0 pb-0 mb-0 pt-1 text-body-2"
                  :class="messageType === 'success'? 'green--text text--darken-2': 'red--text text--darken-2'"
                  elevation="0"
                >
                  {{ message }}
                </v-alert>
              </v-sheet>
            </template>
          </vb-form-row>
        </v-card-text>
        <v-card-actions class="py-4 px-1">
          <v-btn
            :color="isCharibon ? 'secondary' : '#EF0B68'"
            class="white--text text-subtitle-1 text-md-h6 text-md-h6 mt-md-12 mx-auto px-0"
            :width="$vuetify.breakpoint.mdAndUp ? '240px' : '100%'"
            :height="$vuetify.breakpoint.mdAndUp ? '60px' : '48px'"
            :disabled="invalid || disabled"
            @click="unsubscribeNewsletter">解除する</v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-responsive>
</template>

<script>
import {mapActions} from "vuex";
import VbFormRow from "../../molecules/buy/vb-form-row.vue";
import formConfig from "../../../config/form.js";

export default {
  name: "newsletter",
  components: {VbFormRow},
  data() {
    return {
      unsubscribeEmailAddress: null,
      message: null,
      messageType: null,
      siteCode: this.$siteCode,
      disabled: false,
      emailAddressMaxLength: formConfig.emailAddressMaxLength,
    }
  },
  methods: {
    ...mapActions({
      updateMemberFormItems: 'member/updateFormItems',
    }),
    focusBgColorChange(event, errors) {
      const targetNode = event.target.parentNode.parentNode;
      if(event.target.value === "") {
        targetNode.classList.add('input-bg-white');
      }
    },
    blurBgColorChange(event, errors) {
      const targetNode = event.target.parentNode.parentNode;
      if(errors) {
        targetNode.classList.remove('input-bg-white');
      }
    },
    unsubscribeNewsletter() {
      this.disabled = true;
      this.completionMessage = null;

      axios.post('/api/newsletter/unsubscribe', {
        email: this.unsubscribeEmailAddress,
        site_code: this.siteCode,
      }).then(response => {
        if(response.status === 200) {
          this.messageType = 'success';
          this.message = '配信停止の依頼を受け付けました。';
        }
        this.disabled = false;
      }).catch(e => {
        this.disabled = false;
        this.messageType = 'error';
        if (e.response.status === 422) {
          this.message = 'メールアドレスの形式が誤っている可能性があります。';
        } else {
          this.message = 'サーバと通信できませんでした。しばらく時間をおいてからもう一度アクセスして頂くか、管理者にお問い合わせください。';
        }
      });
    }
  },
  computed: {
    isCharibon() {
      return this.$siteCode === VueConfig.siteCode.charibon;
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep {
  .v-text-field__details {
    padding: 4px 0 0 !important;
  }
}
</style>